var map = {
	"./markerAqua.svg": "78d0",
	"./markerBlue.svg": "d5df",
	"./markerMagenta.svg": "a4db",
	"./markerOrange.svg": "cc2a",
	"./markerPurple.svg": "7914",
	"./markerYellow.svg": "4c02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";